// extracted by mini-css-extract-plugin
export default {"kds":"kds_kds__BNx50","kds__gridContainer":"kds_kds__gridContainer__Qz6TM"};